import {
  faClock,
  faPlus,
  faSpinner,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Accordion, AccordionItem, Button } from "react-bootstrap";
import CustomButton from "../../Components/Button";
import {
  convertAvailabiltyArr,
  convertTimeTo12h,
  showToast,
} from "../../utils/helpers";
import SubAvailabilityForm from "./SubAvailabilityForm";
import {
  AvailbilityType,
  SpaceAvailabilityType,
} from "../../Constants/Interfaces";
import { API } from "../../utils/Apis";

const SpaceAvailability: React.FC<SpaceAvailabilityType> = ({
  spaceId,
  availabilities,
  onChange,
}) => {
  const [loading, setLoading] = useState(false);
  const [delLoading, setDelLoading] = useState([]);
  const [dayLoading, setDayLoading] = useState({});
  const [housrsList, setHoursList] = useState<AvailbilityType[]>([]);
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");

  const addItemToAll = () => {
    if (startTime === "") {
      showToast("error", "Please enter start time");
    } else if (endTime === "") {
      showToast("error", "Please enter end time");
    } else if (startTime == endTime) {
      showToast("error", "End time must not be the same as start time.");
    } else if (startTime > endTime) {
      showToast("error", "End time should be greater then start time");
    } else {
      if (!loading) {
        setLoading(true);

        const data = {
          spaceId,
          day: "Mon",
          startTime,
          endTime,
          similarDays: ["Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          replaceOverlapping: "true",
        };

        API.createSpaceAvailability(data)
          .then((res) => {
            const type = res.type === "success" ? "success" : "error";
            showToast(type, res.message);
            if (res.type === "success") {
              setStartTime("");
              setEndTime("");
              const availability = convertAvailabiltyArr(
                res.data.availabilities
              );
              setHoursList(availability);
            }
          })
          .catch((err) => {
            showToast("error", err.message);
          })
          .finally(() => {
            setLoading(false);
          });
      }
    }
  };

  const addItemToDay = (
    day: string,
    startTime: string,
    endTime: string,
    id = ""
  ) => {
    if (!dayLoading[day]) {
      setDayLoading({
        ...dayLoading,
        [day]: true,
      });

      const data = {
        spaceId,
        day,
        startTime,
        endTime,
        similarDays: [],
        replaceOverlapping: id ? "true" : "false",
      };

      if (id) {
        data.id = id;

        API.updateSpaceAvailability(data)
          .then((res) => {
            const type = res.type === "success" ? "success" : "error";
            showToast(type, res.message);

            if (res.type === "success") {
              const availability = convertAvailabiltyArr(
                res.data.availabilities
              );
              setHoursList(availability);
              onChange(availability);

              // setHoursList((prev) =>
              //   prev.map((item) =>
              //     item.day === day
              //       ? { ...item, hours: [...item.hours, { startTime, endTime }] }
              //       : item
              //   )
              // );
            }
          })
          .catch((err) => {
            showToast("error", err.message);
          })
          .finally(() => {
            setDayLoading({
              ...dayLoading,
              [day]: false,
            });
          });
      } else {
        API.createSpaceAvailability(data)
          .then((res) => {
            const type = res.type === "success" ? "success" : "error";
            showToast(type, res.message);

            if (res.type === "success") {
              const availability = convertAvailabiltyArr(
                res.data.availabilities
              );
              setHoursList(availability);
            }
          })
          .catch((err) => {
            showToast("error", err.message);
          })
          .finally(() => {
            setDayLoading({
              ...dayLoading,
              [day]: false,
            });
          });
      }
    }
  };

  const deleteById = (id: string) => {
    const temp = housrsList.map((day) => ({
      ...day,
      hours: day.hours.filter((hour) => hour.id !== id),
    }));

    setHoursList(temp);
  };

  const deleteHourItem = (id, day) => {
    const isLoading =
      delLoading && delLoading[day] && delLoading[day][id]
        ? delLoading[day][id]
        : false;

    if (!isLoading) {
      setDelLoading({
        ...delLoading,
        [day]: {
          ...delLoading[day],
          [id]: false,
        },
      });

      const data = {
        id,
        spaceId,
      };

      API.deleteSpaceAvailability(data)
        .then((res) => {
          const type = res.type ? res.type : "error";
          showToast(type, res.message);

          if (res.type === "success") {
            deleteById(id);
          }
        })
        .catch((err) => {
          showToast("error", err.message);
        })
        .finally(() => {
          setDelLoading({
            ...delLoading,
            [day]: {
              ...delLoading[day],
              [id]: false,
            },
          });
        });
    }
  };

  useEffect(() => {
    const temp = convertAvailabiltyArr(availabilities);
    setHoursList(temp);
  }, [availabilities]);

  useEffect(() => {
    // setSpaceId("ef595a16-df0d-4050-a374-efdd70c1e3df");
  }, []);

  return (
    <>
      <div className="schedule-form-wrapper">
        <h2>Quick setup</h2>
        <p>Apply preset to all days</p>

        <div className="schedule-form">
          <div className="form-group">
            <input
              type="time"
              name="startTime"
              className="form-control"
              value={startTime}
              onChange={(e) => setStartTime(e.target.value)}
            />
          </div>
          <span>to</span>
          <div className="form-group">
            <input
              type="time"
              name="endTime"
              className="form-control"
              value={endTime}
              onChange={(e) => setEndTime(e.target.value)}
            />
          </div>

          <CustomButton
            isLoading={loading}
            title="Apply"
            onClick={() => addItemToAll()}
          />
        </div>
      </div>

      <div className="schedule-times-wrapper">
        <Accordion>
          {housrsList.map((item, index) => {
            const hours = housrsList[index]["hours"]
              ? housrsList[index]["hours"]
              : [0];
            return (
              <AccordionItem eventKey={item.day} key={`${item.day}-${index}`}>
                <SubAvailabilityForm
                  isLoading={dayLoading[item.day]}
                  addItemToDay={(startTime: string, endTime: string, id = "") =>
                    addItemToDay(item.day, startTime, endTime, id)
                  }
                />

                <Accordion.Header>
                  <h5 className="m-0">{item.label}</h5>
                </Accordion.Header>

                <Accordion.Body>
                  {hours && hours.length == 0 && (
                    <div className="no-results">
                      <p className="text-center">
                        No hours added for {item.label}
                      </p>
                    </div>
                  )}

                  {hours && hours.length > 0 && (
                    <div className="hour-item-wrapper">
                      {hours.map((subItem, index) => (
                        <div key={`${item.day}-${index}`} className="hour-item">
                          <span>
                            <FontAwesomeIcon icon={faClock} />

                            {`${convertTimeTo12h(
                              subItem.startTime
                            )} - ${convertTimeTo12h(subItem.endTime)}`}
                          </span>

                          <Button
                            className="delete-btn"
                            onClick={() => deleteHourItem(subItem.id, item.day)}
                          >
                            {delLoading &&
                              delLoading[item.day] &&
                              delLoading[item.day][subItem.id] && (
                                <FontAwesomeIcon
                                  icon={faSpinner}
                                  color="#fff"
                                  spin
                                />
                              )}
                            {(!delLoading ||
                              !delLoading[item.day] ||
                              !delLoading[item.day][subItem.id]) && (
                              <FontAwesomeIcon icon={faTrash} color="#fff" />
                            )}
                          </Button>
                        </div>
                      ))}
                    </div>
                  )}
                </Accordion.Body>
              </AccordionItem>
            );
          })}
        </Accordion>
      </div>
    </>
  );
};

export default SpaceAvailability;
